import Header from "../components/layout/Header";
import HeroSection from "../components/HomePage/HeroSection";
import AboutSection from "../components/HomePage/AboutSection ";
import ProductsSection from "../components/HomePage/ProductsSection ";
import BrandsSection from "../components/HomePage/BrandsSection";
import ServicesSection from "../components/HomePage/ServicesSection";
import TestimonialsSection from "../components/HomePage/TestimonialsSection";
import ContactSection from "../components/HomePage/ContactSection";
import Footer from "../components/layout/Footer";
import SEO from "../components/SEO/SEO";

function Homepages() {
  return (
    <>
      <SEO
        title="Nexora Machinery"
        description="supplier of CNC Turning Centers, Milling Machines, Electrical Tapping Machines, Pallet Trucks, Stackers, Machine Vises, Industrial Accessories, and Metalworking Machinery across India. Get the best quality machines at competitive prices."
        keywords="Nexora Machinery, CNC Turning Center, CNC Lathe Machine, VMC Machine, Vertical Machining Center, Milling Machine, Turret Milling Machine, Electrical Tapping Machine, Drilling Machine, Magnetic Drilling Machine, Pallet Truck, Hydraulic Pallet Truck, Semi Electric Stacker, Electric Stacker, Machine Vise, Industrial Machinery, Metalworking Machinery, Machine Tools, CNC Machine Supplier India, Industrial Equipment Supplier, Coimbatore, Tamil Nadu."
        path="/"
      />
        <Header />
        <HeroSection />
        <AboutSection />
        <ProductsSection />
        <BrandsSection />
        <ServicesSection />
        <TestimonialsSection />
        <ContactSection />
        <Footer />
      </>
      );
}

      export default Homepages;
